import { useContext } from 'react';

import { useStoreWithEqualityFn } from 'zustand/traditional';

import { ConfigContext } from '../contexts';
import type { ConfigStore } from '../stores';

export function useConfigContext<T>(
	selector: (state: ConfigStore) => T,
	equalityFn?: (left: T, right: T) => boolean,
): T {
	const store = useContext(ConfigContext);
	if (!store) {
		throw new Error('Missing ConfigContext.Provider in the tree');
	}
	return useStoreWithEqualityFn(store, selector, equalityFn);
}
